import { render, staticRenderFns } from "./CreateAndUpdate.vue?vue&type=template&id=3a044366"
import script from "./CreateAndUpdate.vue?vue&type=script&lang=js"
export * from "./CreateAndUpdate.vue?vue&type=script&lang=js"
import style0 from "./CreateAndUpdate.vue?vue&type=style&index=0&id=3a044366&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports